<template>
  <div class="deposit-by-accounts-table">
    <template v-for="(d, dind) in displayData">
      <template v-if="d.deposits.length">
        <DottedRow v-if="branches.length > 1"
                   :key="`br-${dind}`"
                   :label="d.title"
                   class="black"
                   :value="formatCurrency(d.branchTotal, true, true)"/>
        <DottedRow v-for="acc in d.deposits"
                   class="pl-3"
                   :key="`br-${dind}-${acc.id}`"
                   :label="acc.deposit_account.title"
                   :value="formatCurrency(acc.amount, true, true)">
          <template #pre-label>
            <span :style="`background-color: ${acc.deposit_account.color}`" class="circle sm mr-1"></span>
          </template>
        </DottedRow>
      </template>
    </template>
  </div>
</template>

<script setup>
import { formatCurrency } from "@/extensions/filters/filters"
import { useStore } from "vuex"
import { computed } from "vue"
import {copyObject} from "@/extensions/prototypes/prototypes"
import DottedRow from "@/components/parts/general/DottedRow.vue"

const store = useStore()

const props = defineProps({
  patient: Object,
  size: String
})

const branches = computed(() => store.state.auth.branches)
const branchId = computed(() => Number(store.state.auth.branch))

const displayData = computed(() =>
    branches.value.map(obj => {
      const deposits = (props.patient?.deposit_by_accounts || []).filter(acc => Number(acc.branch_id) === Number(obj.id)) || []
      obj.deposits = copyObject(deposits)
      obj.branchTotal = deposits.reduce((sum, acc) => sum + Number(acc.amount), 0)
      return obj
    }).sort((a, b) => Number(a.id) === branchId.value ? -1 : (Number(b.id) === branchId.value ? 1 : 0))
)
</script>

<style scoped>
.deposit-by-accounts-table {
  min-width: 280px;
  max-width: 500px;
}
</style>
